module.exports = __webpack_public_path__ + "img/home-case-01.4bd738ed.png";